import { SignupClosed } from "@/components/auth/SignupClosed";
import { SignupForm } from "@/components/auth/SignupForm";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { ErrorState } from "@/components/shared/error-state";
import { useAuthOptions } from "@/hooks/use-auth-options";

export function SignupPage() {
  const options = useAuthOptions();
  return (
    <AuthLayout>
      {options.isPending ? null : options.isError ? (
        <ErrorState message="Couldn't load this page." onRetry={() => options.refetch()} />
      ) : options.data.signUp ? (
        <SignupForm />
      ) : (
        <SignupClosed />
      )}
    </AuthLayout>
  );
}
